import React, {
  useEffect,
  useRef,
  useCallback,
  useState,
  useMemo,
} from 'react';
import { useRouteMatch } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Button, Row, Col } from 'react-bootstrap';
import { FiPlusCircle } from 'react-icons/fi';
import { usePerfil } from '../../hooks/perfil';
import { useToast } from '../../hooks/toast';
import { useAuth } from '../../hooks/auth';

import Input from '../Input';
import SelectSync, { IOption } from '../SelectSync';
import InputMoney from '../InputMoney';
import getValidationErrors from '../../utils/getValidationErrors';
import InputFake from '../InputFake';
import Toggle from '../Exame/Toggle';
import {
  IProcedimento,
  IValoresProcedimento,
  useProcedimento,
} from '../../hooks/procedimentos';
import AddValor from './AddValor';
import { formatPrice } from '../../utils/funcoes';
import LinhaValor from './Linha';
import { useClinica } from '../../hooks/clinica';
import Loading from '../Loading';
import api from '../../services/api';

interface IUrlParams {
  id: string;
}

type Props = {
  procedimento?: IProcedimento;
  setShowModal(values: boolean): void;
  // addProcedimento(
  //   dadosProcedimento: IProcedimento,
  //   perf?: IOption,
  //   proCodigo?: number,
  // ): Promise<boolean>;
};

interface IExameAlvaro {
  Codigo: string;
  Nome: string;
}

const ProcedimentoCadastroPagina: React.FC<Props> = ({
  procedimento,
  setShowModal,
}) => {
  const { optionsPerfil, perfis, buscaPerfil } = usePerfil();
  const { addToast } = useToast();
  const { buscaConvenios, optionsConvenio } = useClinica();
  const { clinica } = useAuth();
  const { addProcedimento } = useProcedimento();
  const { params } = useRouteMatch<IUrlParams>();
  const { id } = params;
  const [proCodigo, setProCodigo] = useState<number | undefined>(
    id ? Number(id) : undefined,
  );
  const [loading, setLoading] = useState(false);
  const [nomePerfil, setNomePerfil] = useState('');
  const formRefProcedimento = useRef<FormHandles>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [optionsPerfis, _] = useState<IOption[]>(optionsPerfil.optionPerfis);
  const [perfilSelecionado, setPerfilSelecionado] = useState<
    number | undefined
  >(undefined);

  const [showAddValor, setShowAddValor] = useState(false);
  const [procedimentoValor, setProcedimentoValor] = useState<
    IValoresProcedimento[]
  >();

  const [loadingExameAlvaro, setLoadingExameAlvaro] = useState(false);
  const [exameAlvaroNome, setExameAlvaroNome] = useState<string>();

  const handleBuscaCodigoAlvaro = useCallback(
    async (codigoAlvaro: string, ProCodigo?: number) => {
      setLoadingExameAlvaro(true);
      setExameAlvaroNome(undefined);
      try {
        if (codigoAlvaro && codigoAlvaro.length > 1) {
          const response = await api.get<IExameAlvaro>(
            `exame/examealvaro/${codigoAlvaro}`,
          );
          if (response.data) {
            setExameAlvaroNome(response.data.Nome);
            const parametroProCodigo = ProCodigo
              ? `?ProCodigo=${ProCodigo}`
              : '';
            await api.get(
              `procedimentos/verificacodigoalvarocadastrado/${codigoAlvaro}${parametroProCodigo}`,
            );
          } else {
            addToast({
              type: 'error',
              title: 'Código Álvaro não encontrato',
              description: 'Entre em contato com suporte para verificação',
            });
            setExameAlvaroNome(
              'Código Álvaro não encontrato. Entre em contato com suporte',
            );
          }
        }
      } catch (error: any) {
        console.log(error);
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefProcedimento.current?.setErrors(errors);
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro ao consultar codigo alvaro',
          description: error?.response?.data?.message
            ? error?.response?.data?.message
            : error.message,
        });
      } finally {
        setLoadingExameAlvaro(false);
      }
    },
    [addToast],
  );

  useEffect(() => {
    async function loadPerfis(): Promise<void> {
      await buscaPerfil();
    }
    if (!optionsPerfil || Object.keys(optionsPerfil).length === 0) loadPerfis();
  }, [buscaPerfil, optionsPerfil]);

  const ehExame = useMemo(() => {
    if (procedimento)
      return perfis.perfis.find(
        p =>
          p.PerIntegracao === true && p.PerCodigo === procedimento.ProPerCodigo,
      );

    if (perfilSelecionado)
      return perfis.perfis.find(
        p => p.PerIntegracao === true && p.PerCodigo === perfilSelecionado,
      );

    return false;
  }, [perfis, perfilSelecionado, procedimento]);

  useEffect(() => {
    async function Busca(): Promise<void> {
      await buscaConvenios();
    }
    if (
      clinica.CliAtendeConvenio &&
      (!optionsConvenio || optionsConvenio.length === 0)
    )
      Busca();
  }, [buscaConvenios, optionsConvenio, clinica.CliAtendeConvenio]);

  useEffect(() => {
    if (procedimento) {
      setProCodigo(procedimento.ProCodigo);

      if (proCodigo) {
        handleBuscaCodigoAlvaro(
          procedimento.ProCodigoAlvaro,
          procedimento.ProCodigo,
        );
        const perf = optionsPerfis.find(
          per => per.value === procedimento.ProPerCodigo?.toString(),
        );

        if (perf) setNomePerfil(perf.label);
      }

      setProcedimentoValor(procedimento.valoresProcedimentoConvenio || []);
    }
  }, [procedimento, optionsPerfis, proCodigo, handleBuscaCodigoAlvaro]);

  const ehNovo = useMemo(() => {
    return !proCodigo || proCodigo === 0;
  }, [proCodigo]);

  const validaPerfil = useMemo(() => {
    if (ehNovo)
      return {
        ProPerCodigo: Yup.number()
          .integer('Perfil obrigatório')
          .typeError('Perfil obrigatório')
          .required('Perfil obrigatório'),
      };
    return {};
  }, [ehNovo]);

  const validaCodigoAlvaro = useMemo(() => {
    if (ehExame)
      return {
        ProCodigoAlvaro: Yup.string().required('Código Alvaro obrigatório'),
      };
    return {};
  }, [ehExame]);

  const pacote = useMemo(() => {
    if (
      procedimento &&
      procedimento.procedimentoPacotes &&
      procedimento.procedimentoPacotes.length > 0
    )
      return true;
    return false;
  }, [procedimento]);

  const handleSubmitProcedimento = useCallback(
    async (dados: IProcedimento) => {
      setLoading(true);
      try {
        let adic = {};
        const ativo = dados.ProAtivo ? dados.ProAtivo.toString() : 'false';

        adic = {
          ...adic,
          ...validaPerfil,
          ...(ativo === 'true' ? validaCodigoAlvaro : {}),
        };

        formRefProcedimento.current?.setErrors({});
        const schema = Yup.object().shape({
          ProNome: Yup.string()
            .min(3, 'Mínimo 3 caracteres')
            .required('Nome é obrigatório'),
          ProValor: Yup.number().required(),
          ProDuracao: Yup.number().required(),
          ProRetorno: Yup.number().required(),
          ProLimite: Yup.number().required(),
          ProValorPlano: Yup.number().required(),
          ProCarencia: Yup.number().required(),
          ProValorPlano2: Yup.number().required(),
          ...adic,
        });

        const procedimentoForm = {
          ...dados,
          ProValorPlanoEmpresarial: 0,
        };

        await schema.validate(procedimentoForm, {
          abortEarly: false,
        });

        if (
          Number(procedimentoForm.ProValorPlano2) <
          Number(procedimentoForm.ProValorPlano)
        ) {
          formRefProcedimento.current?.setFieldError(
            'ProValorPlano2',
            'Valor fora da carência não pode ser menor que valor cartão saúde',
          );
          throw new Error(
            'Valor fora da carência não pode ser menor que valor cartão saúde',
          );
        }

        const perfCodigo = procedimento
          ? procedimento.ProPerCodigo
          : perfilSelecionado;
        const perf = optionsPerfis.find(
          per => per.value === perfCodigo?.toString(),
        );
        let adicionou = false;
        if (ehNovo) {
          adicionou = await addProcedimento(
            {
              ...procedimentoForm,
              ProNome: dados.ProNome.toUpperCase(),
              ProAtivo: ativo === 'true',
              ProFavorito: false,
              ProCodigoTuss: Number(dados.ProCodigoTuss)
                ? dados.ProCodigoTuss
                : 0,
            },
            perf,
          );
        } else {
          adicionou = await addProcedimento(
            {
              ...procedimentoForm,
              ProNome: dados.ProNome.toUpperCase(),
              ProAtivo: ativo === 'true',
              ProFavorito: false,
              ProPerCodigo: undefined,
              ProCodigoTuss: Number(dados.ProCodigoTuss)
                ? dados.ProCodigoTuss
                : 0,
            },
            perf,
            proCodigo,
          );
        }
        setShowModal(!adicionou);
      } catch (error: any) {
        console.log(error);
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefProcedimento.current?.setErrors(errors);
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro ao salvar procedimento',
          description: error?.response?.data?.message
            ? error?.response?.data?.message
            : error.message,
        });
      } finally {
        setLoading(false);
      }
    },
    [
      addToast,
      proCodigo,
      optionsPerfis,
      procedimento,
      ehNovo,
      validaCodigoAlvaro,
      validaPerfil,
      addProcedimento,
      perfilSelecionado,
      setShowModal,
    ],
  );

  const handleOnChange = useCallback((dados: IOption) => {
    setPerfilSelecionado(Number(dados.value));
  }, []);

  const handleFormataValoresConvenio = useCallback(
    (dados: IValoresProcedimento[]) => {
      const procedimentoValorFormatado = dados.map(val => {
        return {
          ...val,
          convenio:
            optionsConvenio.find(
              conv => conv.value === val.ConvCodigo.toString(),
            )?.label || 'ND',
          valorFormatado: formatPrice(val.valor),
        };
      });
      return procedimentoValorFormatado;
    },
    [optionsConvenio],
  );

  const handleChangeCodigoAlvaro = useCallback(async () => {
    const codigoAlvaro = formRefProcedimento.current?.getFieldValue(
      'ProCodigoAlvaro',
    );
    handleBuscaCodigoAlvaro(codigoAlvaro, procedimento?.ProCodigo);
  }, [handleBuscaCodigoAlvaro, procedimento?.ProCodigo]);

  const handleSalvouNovoValor = useCallback(
    (dados: IValoresProcedimento) => {
      const valorAdicionado = handleFormataValoresConvenio([dados]);
      setProcedimentoValor(state => {
        const valoresCadastrados = state?.filter(
          conv => conv.ConvCodigo !== valorAdicionado[0].ConvCodigo,
        );

        if (valoresCadastrados) {
          const valoresAtualizados = valoresCadastrados.concat(valorAdicionado);
          return valoresAtualizados;
        }

        return valorAdicionado;
      });
      setShowAddValor(false);
    },
    [handleFormataValoresConvenio],
  );

  const handleDeletouConvenioValor = useCallback((ConvCodigo: number) => {
    setProcedimentoValor(state => {
      return state
        ? state.filter(conv => conv.ConvCodigo !== ConvCodigo)
        : undefined;
    });
  }, []);

  return (
    <>
      {loading && <Loading />}
      <div className="container">
        <Row noGutters>
          <Col md={12}>
            <Form
              ref={formRefProcedimento}
              initialData={procedimento}
              onSubmit={handleSubmitProcedimento}
            >
              <Row>
                <Col
                  md={12}
                  className={`form-group pr-2 ${proCodigo ? 'd-none' : ''}`}
                >
                  <SelectSync
                    name="ProPerCodigo"
                    label="Perfil"
                    placeholder="Selecione"
                    handleSelectChange={handleOnChange}
                    options={optionsPerfis}
                  />
                </Col>
                <Col
                  md="12"
                  lg="12"
                  className={`form-group pr-2 ${proCodigo ? '' : 'd-none'}`}
                >
                  <InputFake label="Perfil" disabled value={nomePerfil} />
                </Col>
              </Row>
              <Row>
                <Col md={12} className="form-group pr-2">
                  <Input name="ProNome" label="Nome" maxLength={100} />
                </Col>
              </Row>
              <Row className={`${ehExame ? '' : 'd-none'}`}>
                <Col md={3} className="form-group pr-2">
                  <Input
                    name="ProCodigoAlvaro"
                    label="Código Alvaro"
                    onBlur={handleChangeCodigoAlvaro}
                    maxLength={20}
                  />
                </Col>
                <Col md={9}>
                  <InputFake
                    value={
                      loadingExameAlvaro
                        ? 'Procurando correspondência...'
                        : exameAlvaroNome
                    }
                    label="Exame Álvaro"
                    disabled
                  />
                </Col>
              </Row>
              <Row>
                <Col md={4} className="form-group pr-2">
                  <Input
                    name="ProDuracao"
                    label="Duração Padrão"
                    type="number"
                    max={120}
                    min={5}
                    step={5}
                    maxLength={3}
                  />
                </Col>
                <Col md={4} className="form-group pr-2">
                  <Input
                    name="ProRetorno"
                    label="Dias para Retorno"
                    maxLength={3}
                  />
                </Col>
                <Col md={4} className="form-group pr-2">
                  <InputMoney name="ProValor" label="Valor Particular" />
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <InputMoney name="ProValorPlano" label="Valor Cartão Saúde" />
                </Col>

                <Col md={3} className="form-group pr-2">
                  <Input
                    name="ProCarencia"
                    label="Carência Parcela"
                    type="number"
                    max={11}
                    min={0}
                    maxLength={2}
                  />
                </Col>
                <Col md={3} className="form-group pr-2">
                  <InputMoney
                    name="ProValorPlano2"
                    label="Valor Fora Carência"
                  />
                </Col>
                <Col md={3} className="form-group pr-2">
                  <Input
                    name="ProLimite"
                    label="Dias Px. Marcação"
                    type="number"
                    max={360}
                    min={0}
                    maxLength={3}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={4} className="form-group pr-2">
                  <Input
                    name="ProCodigoTuss"
                    label="Código Tuss"
                    type="number"
                    max={999999999}
                    min={0}
                    step={1}
                    maxLength={9}
                  />
                </Col>

                <Col md={3} className="form-group pr-2">
                  <Toggle nome="ProAtivo" label="Ativo" isDisabled={pacote} />
                </Col>

                <Col md={3} className="form-group pr-2 d-none">
                  <Toggle
                    nome="ProFavorito"
                    label="Favorito"
                    isDisabled={false}
                    className="d-none"
                  />
                </Col>
              </Row>
              <Row className="align-items-center border-top p-1">
                <Col md="12">
                  <div className="light-grey text-left pt-3">
                    <>
                      <Button
                        type="submit"
                        variant="success"
                        className="mt-2"
                        disabled={loading}
                      >
                        {loading ? 'Salvando...' : 'Salvar dados'}
                      </Button>
                    </>
                  </div>
                </Col>
              </Row>
            </Form>
            {proCodigo && clinica.CliAtendeConvenio && (
              <>
                {showAddValor && (
                  <AddValor
                    ProCodigo={proCodigo}
                    Adicionou={handleSalvouNovoValor}
                  />
                )}
                <Row
                  noGutters
                  className="bg-light py-2 mt-2 border-top border-bottom"
                  style={{ fontSize: 'Small' }}
                >
                  <Col sm={4} md={4} lg={6}>
                    <b>Convênio</b>
                  </Col>
                  <Col sm={3} md={3} lg={2}>
                    <b>Valor</b>
                  </Col>
                  <Col sm={2} md={2} lg={2}>
                    <b>Retorno</b>
                  </Col>
                  <Col className="pl-2" sm={2} md={2} lg={1}>
                    <Button
                      type="button"
                      size="sm"
                      variant="outline-primary"
                      className="py-0 px-2"
                      onClick={() => setShowAddValor(true)}
                    >
                      <FiPlusCircle size={17} />
                    </Button>
                  </Col>
                  <Col md={1} lg={1}>
                    -
                  </Col>
                </Row>

                {clinica.CliAtendeConvenio &&
                  procedimento &&
                  procedimentoValor &&
                  procedimentoValor.map(tabela => (
                    <LinhaValor
                      key={`${tabela.ConvCodigo}-${tabela.ProCodigo}-${tabela.valor}`}
                      valorConvenio={tabela}
                      handleDeletou={
                        dados => handleDeletouConvenioValor(dados)
                        // eslint-disable-next-line react/jsx-curly-newline
                      }
                    />
                  ))}
              </>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ProcedimentoCadastroPagina;
